'use client';

import dynamic from 'next/dynamic';

const NonScalableSVGDemo = dynamic(
  () => import('./NonScalableSVGDemo')
);

export default NonScalableSVGDemo;
